import { Check, Copy } from "lucide-react";

import { SecretKeyDisplayProps } from "./types";

import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import useCopy from "@/hooks/useCopy";

export const SecretKeyDisplay = ({ secretKey }: SecretKeyDisplayProps) => {
  const { copy, isCopying } = useCopy();

  const handleCopy = () => {
    copy(secretKey);
  };

  return (
    <div className="flex items-center gap-2">
      <div className="relative max-w-xs flex-1">
        <Input
          type="password"
          value={secretKey}
          readOnly
          className="w-full border-gray-200 bg-gray-50 px-3 py-1.5 pr-10 text-sm"
        />
        <Button
          variant="ghost"
          size="sm"
          className="absolute right-0 top-0 h-full px-2"
          onClick={handleCopy}
        >
          {isCopying ? (
            <Check className="h-3.5 w-3.5 text-green-500" />
          ) : (
            <Copy className="h-3.5 w-3.5 text-gray-500" />
          )}
        </Button>
      </div>
    </div>
  );
};
